/**
 * Normalizes AI-generated job description HTML so section headings sit on their own
 * line with body copy in following paragraphs, and spacing is consistent.
 */
export function normalizeJobDescriptionHtml(html: string): string {
  if (!html || typeof html !== "string") return html;

  let s = html.trim();

  // 1) Remove leading <br> inside <p> before <strong> (avoids uneven top spacing)
  s = s.replace(/<p(\s[^>]*)?>\s*(?:<br\s*\/?>\s*)+/gi, "<p$1>");

  // 2) Split "<strong>Heading</strong> body text..." into heading paragraph + body paragraph.
  //    Body must not contain another <strong> (avoids splitting inline bold in one sentence).
  //    Stops before double <br>, next <strong>, or closing </p>
  s = s.replace(
    /<\/strong>\s+((?:(?!<strong)[\s\S])+?)(?=(?:<br\s*\/?>\s*){2}|<strong|<\/p>)/gi,
    (match, body) => {
      const b = body.trim();
      if (!b) return match;
      return `</strong></p><p>${b}`;
    }
  );

  // 3) Double line break before a section heading → new paragraph for the heading
  s = s.replace(/<br\s*\/?>\s*<br\s*\/?>\s*<strong>/gi, "</p><p><strong>");

  // 4) Drop empty paragraphs left by edits
  s = s.replace(/<p([^>]*)>\s*<\/p>/gi, "");
  s = s.replace(/<p([^>]*)>\s*(?:<br\s*\/?>\s*)+<\/p>/gi, "");

  // 5) Collapse accidental </p></p> (no whitespace requirement)
  s = s.replace(/<\/p>\s*<\/p>/gi, "</p>");

  return s.trim();
}
